"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderOptions = exports.GenderLabels = exports.Gender = void 0;
var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
})(Gender || (exports.Gender = Gender = {}));
exports.GenderLabels = {
    [Gender.MALE]: 'Male',
    [Gender.FEMALE]: 'Female'
};
exports.GenderOptions = Object.entries(exports.GenderLabels).map(([value, label]) => ({
    value,
    label
}));
